import { RelayClient } from '@airasia-data/relay-js';

export const hotelExperiment = async (
  variable,
  attributes = {},
  env = 'DEV'
) => {
  const environment = env === 'PRODUCTION' ? 'production' : 'development';
  const client = RelayClient.getInstance(environment);
  const experimentResult = await client.valueAccessor.getValue(
    variable,
    attributes
  );
  return experimentResult;
};

export default async (variable, attributes, env, callback) => {
  const experiment = await hotelExperiment(variable, attributes, env);
  let response = null;
  if (experiment !== null) {
    try {
      response = JSON.parse(experiment);
    } catch (e) {
      console.log(e);
    }
    callback(response);
  }
};
